export default __webpack_public_path__ + "static/media/Identify_Valkyrie.52c297b2.svg";